module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch01"
    }
  }, [_c('a', {
    attrs: {
      "id": "page05"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("CHAPTER ONE")])])])]), _c('div', {
    staticClass: "chapterBody"
  }, [_c('a', {
    attrs: {
      "id": "page05"
    }
  }, [_c('p', {
    staticClass: "chapterOpenerText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "chapterOpenerFirstWords"
  }, [_vm._v("I"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("SABELLA")]), _vm._v(" V"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("ALERI")]), _vm._v(" K"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("ING")])]), _vm._v(" eyed her niece by marriage, approving the strength she saw in Elizabeth’s face. This woman, considered to be the matriarch of the Kings of the Kimberley, understood what family was about—property, heritage, passed from generation to generation.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("There had to be marriage.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("There had to be children.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Elizabeth had three sons, all of them married this past year and two of them begetting children already. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("She")]), _vm._v(" could rest content. Not so Isabella. Of her three grandsons, only Alessandro was planning to marry, and it was not a marriage Isabella favoured.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("The woman of his choice was not right for him.")])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("But how to make him see?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("How to change his mind?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The wedding date was set in December, after the sugarcane had been harvested. It was May now. Six months Isabella had to somehow show Alessandro that Michelle Banks would never settle happily into his life. She was selfish, that one. Selfish and self-centred. But very clever at wheedling her own way, undoubtedly using sex to seduce Alessandro into indulging her.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("How long would that last into their marriage?")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page05"
    }
  }, [_vm._v("And a woman so fussy about preserving her fig")]), _c('a', {
    attrs: {
      "id": "page06"
    }
  }, [_vm._v("ure…pregnancy would certainly not be attractive to her. Would she agree to have even one child, or would there be excuses, delays, outright refusal?")])]), _c('a', {
    attrs: {
      "id": "page06"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“This is a wonderful location, Isabella,” Elizabeth said admiringly, looking out over Dickinson Inlet to the cane fields on the other side.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("They were sitting in the loggia beside the fountain, sharing morning tea, and the open colonnade gave a very different vista to that of the Outback in the Kimberley. Here was the intense green of far north Queensland, and pressing around all the land claimed by man was the tropical rainforest, as primitive on its own unique terms as the vast red heart of Australia.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Isabella remembered how dearly the land had been won; the labour-intensive clearing, the treacherous vines and poisonous plants, the heat, the humidity, the fevers, the deadly snakes. She’d been born amongst the cane fields, to Italian immigrants, seventy-eight years ago.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Apart from the short span of time spent in Brisbane, when she’d met and married Edward King, before he and her brother, Enrico, had gone off to the war in Europe, her home had always been here, on this hill overlooking Port Douglas. This was where she had returned—a war widow—to give birth to the child Edward had given her before he’d gone—their son, her dearly beloved Roberto.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“My father chose the location for my mother who came from Naples,” she explained to her visitor. “She wanted to be by the sea.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page06"
    }
  }, [_vm._v("Elizabeth smiled, appreciating the history. “It’s a ")]), _c('a', {
    attrs: {
      "id": "page07"
    }
  }, [_vm._v("very romantic story…your father building this castle for his bride.”")])]), _c('a', {
    attrs: {
      "id": "page07"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Isabella smiled back at the misnomer. “His villa,” she corrected. “Like the ancient villas of Rome. In the old days this place was known as the Valeri Villa. But because my brother did not return from the war, and I married Edward, my son and my grandsons carried the King name. After my father died, the local people came to call it King’s Castle and the name has stuck.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Is that a sadness to you?” Elizabeth asked quietly. “Having your father’s name and what he created passed over for the King name.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She shook her head. “My father’s bloodline is here. That is what would matter to him. To have what he built remain in the family and be built upon. You understand this, Elizabeth.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She nodded.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I am sure you know it is not easy to achieve,” Isabella continued, needing to talk her problem through with a woman who would comprehend it. “We have disasters here in the tropics, too. You have drought. We have cyclones. I lost my son to a cyclone. That was a very difficult time…Roberto gone, the plantations flattened…”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("A time of loss in every sense.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I sometimes think it’s disasters that forge character,” Elizabeth mused. “To rise above them, to endure…”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“To fight. To keep what you have,” Isabella strongly agreed.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page07"
    }
  }, [_vm._v("Perhaps it was the vital conviction in her voice that ")]), _c('a', {
    attrs: {
      "id": "page08"
    }
  }, [_vm._v("caused Elizabeth to look at her consideringly. What did she see—this niece by marriage to the Kings of the Kimberley? They were both white-haired, dark-eyed, and sat with straight backs. Isabella was almost two decades older, but she didn’t "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("feel")]), _vm._v(" old. Her face might be more wrinkled and she probably had more aches and pains than the younger woman, but inside, the fire for life was still there, the fire for more to be chalked up in whatever time she had left before death stole her away.")])]), _c('a', {
    attrs: {
      "id": "page08"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You have done your father proud, Isabella,” came the quiet summing up. “Holding it all together for your grandsons to grow into men and achieve all they have. The tour of the plantations yesterday…both Rafael and I are very impressed.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“But it can so easily come to an end. The cyclone that took Roberto and his wife…” She shook her head and shot a keen look at Elizabeth. “I want my grandsons married with children to safeguard the future, but they are not obliging me.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Alex…”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You met his fiancée, Michelle Banks, at dinner last night. What did you think of her?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("A hesitation, then slowly, “Very charming…very polished.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Isabella grimaced at the careful comment, her eyes flashing a sharp mockery. “Like a diamond, all sparkly, with a heart and will that’s just as hard. There is no real giving in this young woman.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You’re unhappy with his choice.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“She will not make him a good wife.”")])]), _c('a', {
    attrs: {
      "id": "page09"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("An instant understanding. Appreciation, too, of the dilemma Isabella found herself in. Sympathy. And finally advice. “Then you must find him another woman, Isabella, before it’s too late.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I? How do I do that? It is not as though Alessandro would ever accept an arranged marriage. He has the devil’s pride.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“My eldest son, Nathan, was frittering away the years with unsuitable women. His real life was bound up in the land, as I suspect is the case with Alex.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“True. And Michelle Banks does not share it. To her it is a source of wealth. Nothing more.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I went looking for a woman who could answer Nathan’s needs. I found her. And as it turned out, Nathan answered her needs, so it is a very happy match.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("found")]), _vm._v(" Miranda for Nathan?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Yes. And I put them in each other’s paths. I prayed it would work and it did.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Ah! The paths must cross…with perhaps, some clever angling?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Nothing too obvious. Some little pushes to put them together. It’s impossible to control everything. If there’s no chemistry…”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Ha! What woman wouldn’t want Alessandro?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“The critical point is…he would have to want her, too. Miranda is quite strikingly beautiful. And Michelle is…”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Ah, yes. A very artful beauty. Skin-deep.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Sexually attractive,” Elizabeth reminded her.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page09"
    }
  }, [_vm._v("“Skin and bones. He needs a woman with child-")]), _c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_vm._v("bearing hips and a bosom to suckle the babies. A woman who knows what a proper meal is for a man. And I do not mean lettuce leaves.”")])]), _c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Elizabeth laughed. “Well, don’t forget Alex would have to find her physically attractive, too. If Michelle is any guide, don’t choose a woman on the plump side.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“She can surely have the right curves?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You know him best, Isabella. I think someone with the right attitude might be more important. A woman who could be a partner in every sense.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“A partner. Yes. That’s what Alessandro needs. A true partner. Who will be happy to have his children.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Isabella was highly satisfied with this conversation.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("It was good that Elizabeth had come to visit with her new man, the Argentinian, Rafael Santiso. A fine man, too. He reminded her of her father…a man of vision.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Alessandro could also be a man of vision…if he just opened his eyes and saw what had to be seen to make everything right. She would make him see. She would find the right woman to show him.")])])]), _c('a', {
    attrs: {
      "id": "page10"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page10"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a4f5150","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781426886447_ch01.vue
// module id = 69
// module chunks = 0